<template>
  <div class="row">
    <div
      v-for="(card, index) in cards"
      :key="index"
      class="col-lg-4 col-md-6 col-sm-12 p-3"
    >
      <div class="card__wrapper">
        <div class="card__container">
          <div class="card__content">
            <div class="card__front" :class="card.backgroundClass">
              <h3 class="card__title">{{ card.title }}</h3>
            </div>
            <div class="card__back">
              <div class="card__body">
                <p class="card__fz-ssm" align="justify">
                  {{ card.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const cards = [
  {
    title: "Hardware Deployment & Management",
    backgroundClass: "card__front-background4",
    description:
      "inte-QT provides telecom network connectivity services in more than 190+ countries across the world. It has very strong relationships with carriers and channel partners in the regions and the countries who install Commission, configure telecom equipment's as per the requirements. inte-QT do you have the capabilities to provide hardware deployment services with their management in the far flung and remote areas off the countries. It can deploy hardware such as switches routers. hubs, bridges, firewalls etc. We do manage the hardware devices as per the agreed Service Level Agreements (SLA) and turnaround times (TAT)."
  },
  {
    title: "Security Management",
    backgroundClass: "card__front-background5",
    description:
      "Telecommunication networks today are critical national infrastructure. Safeguarding these networks from attacks, that could lead to unavailability and breach in confidentiality of network services, is very much important now. inte-QT has effective Security management service offerings which ensure the sustainable network performance against those threats. The security solutions are smart, intelligent and autonomous for safeguarding against various kind of network security challenges."
  },
  {
    title: "Network Design & Management",
    backgroundClass: "card__front-background6",
    description:
      "inte-QT provides network design and management services for enterprise customers globally. We have global presence with expertise in Analysis, Planning, Designing and Deployment of a Network including low level designs and high level designs. We design and execute the implementation as per the needs. Our designs are adaptable scalable and can be managed within agreed timelines. We do manage the customer operations efficiently and adheres to quality of service . We have expertise in network designing with cloud and migration towards cloud from existing infrastructures."
  },
  {
    title: "Business Process Outsourcing",
    backgroundClass: "card__front-background7",
    description:
      "inte-QT team offers BPO services in key customer operations like sourcing, order management, network operations and managed services, partner management, contract management, sales analytics, traffic routing and planning, project and service delivery management. inte-QT team is well equipped to handle these outsourced services managing expectations, delivery and cost pressures."
  },
  {
    title: "Cloud Management",
    backgroundClass: "card__front-background8",
    description:
      "inte-QT is the global cloud enabler, we are offering Private cloud, public cloud and Hybrid cloud with High data security, Network redundancy, Low IT infrastructure cost, Unlimited resources, High flexibility. Our Cloud management program improve cloud computing journey with a seamless, flexible, secure, and cost optimized approach. We are managing and delivering IaaS, PaaS, and SaaS cloud computing services with different key global vendors."
  },
  {
    title: "Data Center Connects",
    backgroundClass: "card__front-background9",
    description:
      "inte-QT provides professional solutions of data center towards Planning, Designing, Execution and Optimizing the network. Our data centers solutions have network security with firewall, storage system with data backup, servers with high uptime and application delivery controllers with high application delivery assurance. We offering one stop solution for hosting ,deployment and manage the application, web and other services of customers in data centers."
  }
];
</script>

<style scoped>
:root {
  --level-one: translateZ(3rem);
  --level-two: translateZ(6rem);
  --level-three: translateZ(9rem);
}

.card__wrapper {
  padding: 1rem;
  box-sizing: border-box;
  height: 100%;
}

.card__bodyup {
  display: grid;
  place-items: center;
  height: 100%;
}

.card__container {
  width: 100%;
  margin: 0 auto;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.08);
  border-radius: 15px;
  overflow: hidden;
  background-color: white;
}

.card__content {
  text-align: center;
  position: relative;
  padding: 11em 5em;
  transition: transform 1.5s;
  transform-style: preserve-3d;
}
@media (max-width: 576px) {
  .card__content {
    padding: 12em 5em;
  }
}
.card__container:hover .card__content {
  transform: rotateY(0.5turn);
}

.card__front,
.card__back {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 5em 3em;
  backface-visibility: hidden;
  transform-style: preserve-3d;
  display: grid;
  align-content: center;
}
@media (max-width: 1200px) {
  .card__front,
  .card__back {
    padding: 5em 1em;
  }
}
@media (max-width: 768px) {
  .card__front,
  .card__back {
    padding: 4em 1em;
    margin: 1rem 0;
  }
}

.card__front {
  background-size: cover;
  background-position: center;
  background-blend-mode: overlay;
  color: white;
  border-radius: 15px;
}
.card__back {
  transform: rotateY(0.5turn);
  color: black;
  background: #f3f3f3;
  border-radius: 15px;
}

.card__title {
  font-size: 2.2rem;
  transform: var(--level-three);
}

.card__body {
  transform: var(--level-two);
  font-size: 1rem;
  color: #000;
}

.card__fz-ssm {
  font-size: 0.92rem;
  line-height: 1.5;
}

.card__front-background4 {
  background-image: url("../assets/images/RsfYqvb.jpg");
}
.card__front-background5 {
  background-image: url("../assets/images/FTBMkXL.jpg");
}
.card__front-background6 {
  background-image: url("../assets/images/Lp4jGW6.jpg");
}
.card__front-background7 {
  background-image: url("../assets/images/htECjUe.jpg");
}
.card__front-background8 {
  background-image: url("../assets/images/0Zf9Vzf.jpg");
}
.card__front-background9 {
  background-image: url("../assets/images/TmMIKJl.jpg");
}
</style>
